import React, { useContext, useState } from 'react';
import { Card } from '@usealloy/component-library';

import WatchlistReview from '~/entities/evaluations/watchlist-review/WatchlistReview';
import JourneyApplicationContext from '~/application-review/context';

import { useEventTypeEvaluationsContext } from '../context';

const WatchlistMatches = () => {
  const { evaluation, constructWatchlistMatchDataObject } = useEventTypeEvaluationsContext();
  const { currentAgentIsAssigned } = useContext(JourneyApplicationContext);

  const [matchInfo] = useState(constructWatchlistMatchDataObject(
    evaluation.final_response,
  ));

  if (matchInfo.length === 0) {
    return null;
  }

  return (
    <Card
      header="Watchlist Matches"
      collapsible
      contentGap={0}
    >
      <WatchlistReview
        canAgentResolve={currentAgentIsAssigned}
        entityToken={evaluation.entity_token}
        evaluationToken={evaluation.evaluation_token}
        showLatestDecisions
      />
    </Card>
  );
};

export default WatchlistMatches;
